import React, { ReactNode } from "react";
import OriAvatar from "./OriAvatar";
import styles from "./OriPersonaCard.module.scss";

interface OriPersonaCardProps {
  message: ReactNode;
  messageFooter?: ReactNode;
  label?: string;
  avatarSize?: number;
  testId?: string;
}

function renderStringMessage(message: string) {
  const paragraphs = message
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);
  return (
    <div className={styles.bodyStack}>
      {paragraphs.map((paragraph, index) => (
        <p key={index} className={styles.body}>
          {paragraph}
        </p>
      ))}
    </div>
  );
}

const OriPersonaCard: React.FC<OriPersonaCardProps> = ({
  message,
  messageFooter,
  label = "Ori",
  avatarSize = 72,
  testId = "ori-persona-card",
}) => (
  <div className={styles.container} data-testid={testId}>
    <OriAvatar size={avatarSize} />
    <div className={styles.textColumn}>
      <p className={styles.label}>{label}</p>
      {typeof message === "string" ? renderStringMessage(message) : message}
      {messageFooter ? <div className={styles.footer}>{messageFooter}</div> : null}
    </div>
  </div>
);

export default OriPersonaCard;
